import script from "./RecentIntiative.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentIntiative.vue?vue&type=script&setup=true&lang=js"

import "./RecentIntiative.vue?vue&type=style&index=0&id=71e52f06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e52f06"]])

export default __exports__